import React from "react";
import { useSetAtom } from "jotai";
import { Star, ExternalLink } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { androidReviewDialog } from "@/state/dialogs";
import { useTranslation } from "@/hooks/useTranslation";
import { GOOGLE_PLAY_URL } from "@/config/constants";

type AndroidReviewDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export const AndroidReviewDialog = ({ open, onOpenChange }: AndroidReviewDialogProps) => {
  const setAndroidReviewDialogOpen = useSetAtom(androidReviewDialog);
  const { t } = useTranslation();

  const handleReviewClick = () => {
    // Open Google Play Store review page
    window.open(GOOGLE_PLAY_URL, "_blank");
    setAndroidReviewDialogOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="flex space-x-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <Star key={star} className="w-8 h-8 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
          </div>
          <DialogTitle className="text-xl font-semibold">
            {t("android_review_dialog.title")}
          </DialogTitle>
          <DialogDescription className="text-base text-muted-foreground mt-2">
            {t("android_review_dialog.description")}
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col space-y-3 mt-6">
          <Button
            onClick={handleReviewClick}
            className="w-full flex items-center justify-center space-x-2"
          >
            <Star className="w-4 h-4" />
            <span>{t("android_review_dialog.rate_button")}</span>
            <ExternalLink className="w-4 h-4" />
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
